export const EVENT_TYPE = {
  VIDEO: 1,
  MEETING: 2,
  WEBINAR: 3,
  LIVE: 4,
  ONE_ON_ONE: 5,
  PROGRAM: 6,
  PITCH_EVENT: 7,
  SERVICE: 8,
  PRODUCT: 9,
  TRAINING_SESSION: 10,
  1: 'VIDEO',
  2: 'MEETING',
  3: 'WEBINAR',
  4: 'LIVE',
  5: 'ONE_ON_ONE',
  6: 'PROGRAM',
  7: 'PITCH_EVENT',
  8: 'SERVICE',
  9: 'PRODUCT',
  10: 'TRAINING_SESSION',
};
